/* -------------------------
   FIX: debounce()
-------------------------- */
function debounce(func, wait, immediate) {
  let timeout;
  return function () {
    const context = this, args = arguments;
    const later = function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    const callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}

/* -------------------------
   Wishlist Core Class
-------------------------- */
class dT_WhistList {

  constructor() {
    this.wishListData = [];

    this.LOCAL_STORAGE_WISHLIST_KEY = 'shopify-wishlist';
    this.LOCAL_STORAGE_DELIMITER = ',';
  }

  setListLocalStorageKey(LOCAL_STORAGE_WISHLIST_KEY, LOCAL_STORAGE_DELIMITER) {
    this.LOCAL_STORAGE_WISHLIST_KEY = LOCAL_STORAGE_WISHLIST_KEY;
    this.LOCAL_STORAGE_DELIMITER = LOCAL_STORAGE_DELIMITER;
  }

  setupGrid() {
    var wishlist = this.getWishlist();

    var requests = wishlist.map(function (handle) {
      var productTileTemplateUrl = '/products/' + handle + '?view=json';
      return this.getProductResponse(productTileTemplateUrl);
    }.bind(this));

    return Promise.all(requests).then(function (responses) {
      var wishlistProductCards = responses.join('%$$%');

      var a_wishlistRecords = wishlistProductCards.split("%$$%");
      let recordsObj = [];

      if (Array.isArray(a_wishlistRecords) && a_wishlistRecords.length) {
        var index = 0;
        a_wishlistRecords.forEach(record => {
          var a_record = record.split("~~");

          var recordObj = {
            id: a_record[0],
            product_title: a_record[1],
            product_handle: a_record[2],
            product_image: a_record[3],
            vendor: a_record[4],
            type: a_record[5],
            money_price: a_record[6],
            price_min: a_record[7],
            price_max: a_record[8],
            available: a_record[9],
            price_varies: a_record[10],
            variant_id: a_record[11],
            variant_title: a_record[12],
            sku: a_record[13],
            description: a_record[14],
            quantity: "1",
            product_url: '/products/' + a_record[2]
          };

          recordsObj[index] = recordObj;
          index++;
        });
      }

      return recordsObj;

    }.bind(this)).then(function (data) {

      this.wishListData = data;

      return data;

    }.bind(this));

  }

  getWishListRecords() {
    return this.wishListData;
  }

  getProductResponse(url) {
    return fetch(url)
      .then((response) => {
        return response.text();
      })
      .then((data) => {
        return data.replace(/^\s*[\r\n]/gm, '');
      });
  }

  getTotalCount() {
    return this.getWishlist().length;
  }

  getWishlist() {
    var wishlist = localStorage.getItem(this.LOCAL_STORAGE_WISHLIST_KEY) || false;
    if (wishlist) return wishlist.split(this.LOCAL_STORAGE_DELIMITER);
    return [];
  }

  setWishlist(array) {
    var wishlist = array.join(this.LOCAL_STORAGE_DELIMITER);
    if (array.length) localStorage.setItem(this.LOCAL_STORAGE_WISHLIST_KEY, wishlist);
    else localStorage.removeItem(this.LOCAL_STORAGE_WISHLIST_KEY);
    return wishlist;
  }

  updateWishlist(handle) {
    var wishlist = this.getWishlist();
    var indexInWishlist = wishlist.indexOf(handle);
    if (indexInWishlist === -1) wishlist.push(handle);
    else wishlist.splice(indexInWishlist, 1);
    return this.setWishlist(wishlist);
  }

  removeWhishlist(handle) {
    var wishlist = this.getWishlist();
    wishlist = this.remove(wishlist, handle);
    return this.setWishlist(wishlist);
  }

  resetWishlist() {
    return this.setWishlist([]);
  }

  isAddedIntoList(handle) {
    var wishlist = this.getWishlist();
    return wishlist.includes(handle);
  }

  remove(arr) {
    var what, a = arguments, L = a.length, ax;
    while (L > 1 && arr.length) {
      what = a[--L];
      while ((ax = arr.indexOf(what)) !== -1) {
        arr.splice(ax, 1);
      }
    }
    return arr;
  }
}


/* -------------------------
   PRODUCT PAGE WISHLIST
-------------------------- */
class dTXWhishList extends HTMLElement {
  constructor() {
    super();

    this.dTWhistList = new dT_WhistList();

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    this.addWishList = this.querySelector('.add-wishlist');

    if (!this.addWishList) return;

    this.productHandle = this.addWishList.getAttribute('data-product_handle');
    this.addWishList.addEventListener('click', this.debouncedOnSubmit.bind(this));

    this.initLoad();
  }

  onSubmitHandler(event) {
    event.preventDefault();

    // ❤️ FIX: REMOVE 404 REDIRECT + TOGGLE HEART
    if (this.dTWhistList.isAddedIntoList(this.productHandle)) {

      // REMOVE FROM WISHLIST
      this.dTWhistList.updateWishlist(this.productHandle);
      this.addWishList.classList.remove("added");
      this.addWishList.classList.add("removed");

      // Update wishlist count
      const count = this.dTWhistList.getTotalCount();
      document.querySelectorAll(".dtxc-wishlist-count, .mobile-dtxc-wishlist-count")
        .forEach(el => el.setAttribute("count", count));

    } else {

      // ADD TO WISHLIST
      this.addWishList.classList.add("adding");
      this.dTWhistList.updateWishlist(this.productHandle);

      setTimeout(this.postAdd.bind(this), 800);
    }
  }

  postAdd() {
    const dtxwishCount = document.getElementsByClassName('dtxc-wishlist-count');

    if (dtxwishCount.length > 0) {
      if (document.querySelector(".dtxc-wishlist-count"))
        document.querySelector(".dtxc-wishlist-count").setAttribute('count', this.dTWhistList.getTotalCount());
      if (document.querySelector(".mobile-dtxc-wishlist-count"))
        document.querySelector(".mobile-dtxc-wishlist-count").setAttribute('count', this.dTWhistList.getTotalCount());
    }

    this.addWishList.classList.remove("adding");
    this.addWishList.classList.add("added");
  }

  initLoad() {
    if (this.dTWhistList.isAddedIntoList(this.productHandle)) {
      this.addWishList.classList.add("added");
    }
  }
}

customElements.define('dtx-wishlist', dTXWhishList);


/* -------------------------
   WISHLIST GRID PAGE
-------------------------- */
class dTXWhishListGrid extends HTMLElement {
  constructor() {
    super();

    this.gridTemplate = this.querySelector('.grid_template');
    this.dtxTable = this.querySelector(".dtx-table");
    this.dtxNoRecord = this.querySelector(".dtx-grid-empty");

    this.grid_type = this.getAttribute('grid_type');
  }

  connectedCallback() {
    this.initLoad();
  }

  initLoad() {
    var dTWhistList = new dT_WhistList();

    dTWhistList.setupGrid().then(function (data) {
      this.generateGrid(data);
      return data;
    }.bind(this));
  }

 generateGrid(a_records) {
  if (a_records.length === 0) {

    // Hide table
    this.dtxTable.style.display = "none";

    // Force show empty wishlist message
    this.dtxNoRecord.style.display = "block";
    this.dtxNoRecord.style.opacity = "1";
    this.dtxNoRecord.style.visibility = "visible";
    this.dtxNoRecord.style.height = "auto";

    return;
  }


    a_records.forEach(function (record) {
      var newRow = this.dtxTable.insertRow(this.dtxTable.rows.length);
      newRow.id = 'row_' + record.id;
      newRow.innerHTML = this.buidRow(record);
    }.bind(this));

    this.dtxNoRecord.classList.add("dtx-grid-hide");
    this.dtxTable.classList.add("dtx-grid-show");
  }

  buidRow(record) {
    var templateData = this.gridTemplate.innerHTML;
    Object.keys(record).forEach(key => {
      templateData = templateData.replace(new RegExp(`{item.${key}}`, 'gi'), record[key] || '');
    });
    return templateData;
  }
}

customElements.define('dtx-wishlist-grid', dTXWhishListGrid);


/* -------------------------
   REMOVE ITEM
-------------------------- */
class dTXRemoveWishItem extends HTMLElement {
  constructor() {
    super();

    this.removeItem = this.querySelector('.remove-item');
    if (!this.removeItem) return;

    this.debouncedOnSubmit = debounce((event) => {
      this.removeListItem(event);
    }, 500);

    this.productHandle = this.removeItem.getAttribute('data-product_handle');

    this.removeItem.addEventListener('click', this.debouncedOnSubmit.bind(this));
  }

  removeListItem(event) {
    event.preventDefault();

    var dTWishList = new dT_WhistList();
    dTWishList.removeWhishlist(this.productHandle);

    window.location.reload();
  }
}

customElements.define('dtx-remove-wish-item', dTXRemoveWishItem);


/* -------------------------
   Wishlist Count (Desktop)
-------------------------- */
class dTXWishCount extends HTMLElement {

  static get observedAttributes() { return ['count']; }

  constructor() {
    super();

    this.gridCountBubble = this.querySelector('.grid-count-bubble');

    this.initLoad();
  }

  initLoad() {
    var dTWishList = new dT_WhistList();
    var totalCount = dTWishList.getTotalCount();

    this.gridCountBubble.querySelector("span").innerHTML = totalCount;
  }

  attributeChangedCallback() {
    this.initLoad();
  }
}

customElements.define('dtx-wish-count', dTXWishCount);


/* -------------------------
   Wishlist Count (Mobile)
-------------------------- */
class MobiledTXWishCount extends HTMLElement {

  static get observedAttributes() { return ['count']; }

  constructor() {
    super();

    this.gridCountBubble = this.querySelector('.grid-count-bubble');

    this.initLoad();
  }

  initLoad() {
    var dTWishList = new dT_WhistList();
    var totalCount = dTWishList.getTotalCount();

    this.gridCountBubble.querySelector("span").innerHTML = totalCount;
  }

  attributeChangedCallback() {
    this.initLoad();
  }
}

customElements.define('mobile-dtx-wish-count', MobiledTXWishCount);
